<template>
  <div id='order'>
    
    <v-card>
      <v-card-title>
        Your Order
        <div class="flex-grow-1" />
        <v-text-field
          v-model="orderSearch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    
      <v-data-table
        :headers="headers"
        :items="myProducts"
        :search="orderSearch"
        item-key="index"
        group-by="type"
        class="elevation-1"
      >

        <!-- Adds a mini image into the table -->
        <template v-slot:item.icon="{ item }">
         <v-avatar>
            <img :src="item.image_url" alt="image">
          </v-avatar>
        </template>

        <template v-slot:body.append>
          <tr>
            
            <td colspan="3">
              <v-textarea
                v-model="orderNote"
                placeholder="Any special notes or requests can go here."
                label="Order Notes"
                outlined
                hide-details
                style="margin-top: 40px; margin-bottom: 20px;"
              ></v-textarea>
            <td colspan="1"></td>
            <td colspan="5" class="font-weight-medium">
              <br>
              Estimated Item Total: {{orderTotal ? '$' + orderTotal.toFixed(2) : '$0.00'}} <br>
              <font class="caption"> Total does not include shipping and some customization requests. </font>
              <br>
              <v-row justify="space-between">
                  <v-btn 
                    rounded 
                    color="primary" 
                    :disabled="myProducts <= 0" 
                    class="order-btn"
                    @click="downloadOrder"
                  >
                    Download Order
                  </v-btn>
                  <v-btn 
                    rounded 
                    color="primary" 
                    :disabled="myProducts <= 0" 
                    class="order-btn"
                  >
                    Send Order
                  </v-btn>
              </v-row>
            </td>
          </tr>
        </template>

        <!-- Adds a mini image into the table
        <template v-slot:item.selection_str="{ item }">
          <v-text-field
            solo
            v-model="item.selection_str"
          ></v-text-field>
        </template> -->

        <!-- Gives add and remove options -->
        <template v-slot:item.actions="{ item, index }">
          <v-btn icon @click="handleClickProduct(item, index)">
            <v-icon color="blue"> mdi-pencil </v-icon>
          </v-btn>
          <v-btn icon @click="removeProduct(item)">
            <v-icon color="red"> mdi-delete </v-icon>
          </v-btn>
        </template>
         
      </v-data-table>
    </v-card>

    
    <ProductView 
      :debug="debug" 
      :item="selectedProduct" 
      :opened="editProduct" 
      :setChoices="selectedChoices" 
      :setQuantity="selectedQuantity" 
      @close="editProduct = false" 
      @update="updateProduct($event)" 
    ></ProductView>
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

// import { firebase } from '@/utils/firebase'

export default {
  name: 'order',
  data () {
      return {
        orderSearch: null,
        editProduct: false,
        selectedProduct: null,
        selectedChoices: [],
        selectedQuantity: 0,
        headers: [
          { text: '', value:'icon', sortable: false},
          { text: 'Index', value: 'index', sortable: false },
          { text: 'Title', value: 'title', sortable: false },
          { text: 'Variant', value: 'selection_str', sortable: false },
          { text: 'Unit Price', value: 'price_str', sortable: false },
          { text: 'Quantity', value: 'quantity', sortable: false },
          { text: 'Item Total', value: 'total_str', sortable: false },
          { text: 'Code', value: 'orderCode', sortable: false },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        orderCSV: '',
        orderNote: '',
          
      }
  },
  mounted() {
  
  },
  computed: {
    ...mapGetters({
      debug: 'getDebug',
      loading: 'getLoading',
      allProducts: 'getAllProducts',
      myProducts: 'getThisOrder'
    }),
    orderTotal: function() {
      let total = 0
      this.myProducts.forEach((element) => {
        total += Number(element.total)
      })
      return total
    }
  },
  methods: {
    handleClickProduct(item, index) {
      if(this.debug) console.log('selectedProduct is:', item)
      if(this.debug) console.log('item index is:', index)
      
      this.selectedProduct = item
      this.selectedChoices = item.selection
      this.selectedQuantity = item.quantity

      this.editProduct = true
      
      // this.editProduct = true
      
    },
    updateProduct(item) {
      if(this.debug) console.log(item)
      this.$store.dispatch('updateProduct', item)
      this.editProduct = false
    },
    removeProduct(item) {
      if(this.debug) console.log('Removing index:', item)
      this.$store.dispatch('removeProduct', item)
    },
    resetProduct() {
      this.selectedProduct = null
    },
    downloadOrder() {

      //generate CSV
      let headers = [
          'Title',
          'Code',
          'Variant',
          'Description',
          'Quantity',
          'Price Per Unit',
          'Total Line Item'
      ]

      // //Reservation CSV Builder
      let csv = ''
      let now = new Date()
      
      // //Headers
      headers.forEach((column) => {
          csv += column + ','
      })
      csv += '\n'

      //Row Builder
      this.myProducts.forEach((product) => {
          let line = ''
          line += product.title + ','
          line += product.orderCode ? product.orderCode + ',' : 'none' + ','
          line += product.selection_str.replace(/,/g,'.') + ','
          line += product.description + ','
          line += product.quantity + ','
          line += product.price_str + ','
          line += product.total_str + ','
          csv += line + '\n'

      })

      csv += '\n'
      csv += `* Generated ${now.toLocaleDateString()} \n`
      csv += `** User <UserName>  \n`
      csv += `*** Order Note: ${this.orderNote.replace(/,/g,'..')}  \n`

      this.orderCSV = csv

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(this.orderCSV);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'order.csv';
      hiddenElement.click();
    }
  },
  watch: {
    'editProduct': {
      handler: function(newVal, oldVal) {
        if(newVal != oldVal && newVal == false) {
          this.resetProduct()
        }
      },
    },
  }
}
</script>

<style scoped>

#catalog {
  width: 100%;
  height: auto;
  min-height: 500px;
  align-content: center;
  padding-left: auto;
  padding-right: auto;
  position: relative;
}

#product-dialog {
  width: 90%;
  max-width: 500px;
}

.order-btn {
  width: 40%;
  margin: 20px;
}

</style>



